import { type PropsWithChildren } from "react";

import { twMerge } from "@/utils/twMerge";

type Props = {
  className?: string;
};

export function NodePointer({ children, className }: PropsWithChildren<Props>) {
  return (
    <div className={twMerge("relative pl-[9px] group/pointer", className)}>
      <div className="w-[9px] h-[19px] border-gray-300 dark:border-gray-500 border-l-[1px] border-b-[1px] absolute left-0 top-0 rounded-bl" />
      {children}
      <div className="w-[1px] border-gray-300 dark:border-gray-500 border-l-[1px] h-full absolute top-0 left-0 group-last/pointer:hidden" />
    </div>
  );
}
